/**
 * GiftFeud Learning Bite SDK
 * Official SDK for embedding learning bites in any application
 * 
 * @packageDocumentation
 */

// Import styles
import './styles/index.css';

// Core SDK
export { GiftFeudSDK } from './core/GiftFeudSDK';

// React Components
export { LearningBiteViewer } from './components/LearningBiteViewer';
export type { LearningBiteViewerProps } from './components/LearningBiteViewer';

// UI Components
export { Button } from './components/ui/Button';
export type { ButtonProps } from './components/ui/Button';
export { Textarea } from './components/ui/Textarea';
export type { TextareaProps } from './components/ui/Textarea';

// Types
export type {
  Environment,
  SDKConfig,
  LearningBite,
  ShareSettings,
  Slide,
  SlideType,
  ContentType,
  LearningQuestion,
  QuestionOption,
  SDKError,
  AuthorizationResponse,
  CompletionData,
} from './types';

// Version
export const SDK_VERSION = '1.2.4';

